import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaSearch, FaTrash } from "react-icons/fa";
import { useState, useRef, useEffect } from "react";
import { PlaySounds } from "../../../functions/playSounds.js";
import MessageAlert from "../../../components/messageAlert.jsx";
import Select from "react-select";
import { axiosServer } from "../../../axiosServer.js";
import buildLink from "../../../urls.js";
import axios from "axios";
import Cookies from "js-cookie";
import Loader from "../../../components/loader.jsx";

const RestockWH = () => {
  const productIdRef = useRef(null);
  const addressRef = useRef(null);

  const [productId, setProductId] = useState("");
  const [address, setAddress] = useState("bin");
  const [addressValue, setAddressValue] = useState("");
  const [warehouses, setWarehouses] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [productInf, setProductInf] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState("7");

  const { playErrorSound, playSuccessSound } = PlaySounds();
  const history = useNavigate();

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  useEffect(() => {
    if (productIdRef.current) {
      productIdRef.current.focus();
    }
  }, []);

  const restockProductFromPallet = async () => {
    if (!productId) {
      setError("Please scan a product ID.");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      playErrorSound();
      return;
    }

    if (!addressValue) {
      setError("Please enter an address.");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      playErrorSound();
      return;
    }

    setLoading(true);
    setError("");

    try {
      const userId = getUserIdFromLocalStorage();
      const requestBody = {
        barcode: productId,
        address_value: addressValue,
        address_type: "bin",
        user_id: userId,
      };

      const response = await axiosServer.post(
        buildLink("restockProductFromPallet"),
        requestBody
      );

      if (response.data && response.data.success) {
        playSuccessSound();
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 2000);
      } else {
        throw new Error(response.data?.message || "Failed to restock product");
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || err.message || "An error occurred";
      setError(errorMessage);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      playErrorSound();
    } finally {
      setLoading(false);
      setProductId("");
      setAddressValue("");
      setProductInf(null)
      if (productIdRef.current) {
        productIdRef.current.value = "";
        productIdRef.current.focus();
      }
      if (addressRef.current) {
        addressRef.current.value = "";
      }
    }
  };

  const handleTrashClick = () => {
    setProductId("");
    if (productIdRef.current) {
      productIdRef.current.value = "";
      productIdRef.current.focus();
    }
  };

  const handleAddressTrashClick = () => {
    setAddressValue("");
    if (addressRef.current) {
      addressRef.current.value = "";
      addressRef.current.focus();
    }
  };

  const fetchWarehouses = async () => {
    try {
      const url = buildLink(`fetchtowarehouse`);
      const response = await axiosServer.get(url);

      if (response.data.success) {
        setWarehouses(response.data.data || []);
      } else {
        setError("Failed to fetch warehouses.");
      }
    } catch (err) {
      setError("Failed to fetch warehouses.");
    }
  };

  const searchProduct = async (e) => {
    e.preventDefault();

    setLoadingSearch(true);

    const item = productIdRef.current.value;

    try {
      const url =
        buildLink("getWarehouseProductDetails") +
        `&product=${item}` +
        `&warehouse_id=${selectedWarehouseId}`;
      await axiosServer.get(url).then((response) => {
        if (response.data.success) {
          setProductInf(response.data.product);
          playSuccessSound();
          addressRef.current.focus();
        }
      });
      setLoadingSearch(false);
    } catch (e) {
      setLoadingSearch(false);
      productIdRef.current.focus();
      productIdRef.current.value = "";
      playErrorSound();
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  const handleWarehouseChange = (selectedOption) => {
    const warehouseId = selectedOption ? selectedOption.value : null;
    setSelectedWarehouseId(warehouseId);

    // Save to cookies for 1 day
    if (warehouseId) {
      Cookies.set("selectedWarehousemanageupc", warehouseId, { expires: 1 });
    } else {
      Cookies.remove("selectedWarehousemanageupc");
    }
  };

  useEffect(() => {
    fetchWarehouses();
  }, []);

  return (
    <>
      <div className="mb-5 sticky top-0 flex flex-col bg-white z-50">
        <div className="w-full bg-dbase h-16">
          <div className="container px-3 relative flex justify-between w-full text-white h-full">
            <div className="flex gap-7 flex-row justify-start">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className="text-xl my-auto">Restock Awaiting failed given</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4">
        <form
          onSubmit={(e) => e.preventDefault()}
          className="flex flex-col gap-4"
        >
          <div className="relative flex-1">
            <label
              className="flex mb-1"
            >WareHouse</label>
            <Select
              placeholder="Select Warehouse"
              required
              onChange={handleWarehouseChange}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "7px",
                  borderColor: state.isFocused ? "grey" : "grey",
                  padding: "8px 5px",
                }),
              }}
              options={
                warehouses.length > 0
                  ? warehouses.map((warehouse) => ({
                    value: warehouse.warehouse_id,
                    label: warehouse.warehouse_name,
                  }))
                  : []
              }
              value={
                selectedWarehouseId
                  ? warehouses
                    .map((warehouse) => ({
                      value: warehouse.warehouse_id,
                      label: warehouse.warehouse_name,
                    }))
                    .find((option) => option.value === selectedWarehouseId)
                  : null
              }
              className="w-full"
            />
          </div>

          <form className="flex flex-col justify-center gap-0">
            <label
              className="flex mb-1 "
            >Product ID</label>
            <div className="flex flex-row items-center gap-3">
              <div className="relative flex-1">
                <input
                  ref={productIdRef}
                  type="text"
                  value={productId}
                  onChange={(e) => setProductId(e.target.value)}
                  className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                  placeholder="Scan product ID"
                />
                <div onClick={handleTrashClick}>
                  <FaTrash className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20" />
                </div>
              </div>
              <button
                type="submit"
                className="bg-dbase rounded-md text-white px-5 h-12"
                onClick={(e) => searchProduct(e)}
              >
                {loadingSearch ? <Loader /> : <FaSearch />}
              </button>
            </div>
          </form>

          {productInf?.address && (
            <p className="font-bold text-dblack">
              Address: {productInf?.address}
            </p>
          )}
          {/* <div> <label
            className="flex mb-1"
          >Address Type</label>
            <Select
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "7px",
                  borderColor: state.isFocused ? "grey" : "grey",
                  padding: "8px 5px",
                }),
              }}
              value={{
                value: address,
                label: address.charAt(0).toUpperCase() + address.slice(1),
              }}
              onChange={(selectedOption) => setAddress(selectedOption.value)}
              options={[
                { value: "bin", label: "Bin" },
                { value: "upc", label: "Upc" },
              ]}
              defaultValue={{ value: "bin", label: "Bin" }}
              placeholder="Select Warehouse"
              className="w-full"
            />
          </div> */}
          <div className="relative flex-1">
            <label
              className="flex mb-1"
            >Address</label>
            <input
              ref={addressRef}
              type="text"
              value={addressValue}
              onChange={(e) => setAddressValue(e.target.value)}
              className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
              placeholder="Address"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  restockProductFromPallet(e);
                }
              }}
            />
            <div>
              <FaTrash
                onClick={() => handleAddressTrashClick()}
                className="absolute top-12 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
              />
            </div>
          </div>
        </form>
      </div>
      <MessageAlert
        message={error || "Successfully added to restock list!"}
        type={showMessgErr ? "err" : "succ"}
        showMessg={showMessgErr || showMessgSucc}
      />
    </>
  );
};

export default RestockWH;
